"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const company_detail_entity_1 = require("../../../../service-lib/src/lib/entities/company-detail.entity");
const company_document_map_entity_1 = require("../../../../service-lib/src/lib/entities/company-document-map.entity");
const company_gst_detail_entity_1 = require("../../../../service-lib/src/lib/entities/company-gst-detail.entity");
const company_address_entity_1 = require("../../../../service-lib/src/lib/entities/company.address.entity"); // Import the mapping entity
const company_entity_1 = require("../../../../service-lib/src/lib/entities/company.entity");
const file_upload_entity_1 = require("../../../../service-lib/src/lib/entities/file-upload.entity");
const group_comapny_map_entity_1 = require("../../../../service-lib/src/lib/entities/group-comapny-map.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const opportunity_entity_1 = require("../../../../service-lib/src/lib/entities/opportunity.entity");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const entities_1 = require("../../../../service-lib/src/lib/entities");
const constants_2 = require("../../../../service-lib/src/lib/constants");
let CompanyRepository = class CompanyRepository {
    constructor(companyRepository, lookUpRepository, opportunityRepository, entityService, scopeService) {
        this.companyRepository = companyRepository;
        this.lookUpRepository = lookUpRepository;
        this.opportunityRepository = opportunityRepository;
        this.entityService = entityService;
        this.scopeService = scopeService;
    }
    // Creates a new company entity and saves it to the database.
    async createCompany(entityManager, companyData) {
        try {
            const company = entityManager.create(company_entity_1.Company, companyData);
            return await entityManager.save(company);
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError) {
                const constraint = error.constraint; // Extract the constraint name
                if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicatePanEntry) {
                    // Unique constraint violation for PAN
                    throw new Error(messages_1.errorMessages.DulicatePanEntry);
                }
                else if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicateTanEntry) {
                    // Unique constraint violation for TAN
                    throw new Error(messages_1.errorMessages.DuplicateTanEntry);
                }
            }
            throw error;
        }
    }
    // Create a new company details entity and save it to the database
    async createCompanyDetails(entityManager, detailsData) {
        const details = entityManager.create(company_detail_entity_1.CompanyDetail, detailsData);
        return entityManager.save(details);
    }
    async getCompanyById(companyId, userId) {
        try {
            // const editable
            const editValidation = await this.scopeService.validateResourceScope(userId, constants_1.DEFAULT_COMPANY_ENTITY_NAME, "edit", companyId);
            const company = await this.companyRepository.findOne({
                where: { id: companyId },
                relations: [
                    "details",
                    "companyAddresses",
                    "companyAddresses.address",
                    "companyAddresses.address.addressType",
                    "stateGstDetails.gstCategory",
                    "groupCompanyMaps",
                    "groupCompanyMaps.groupCompany",
                    "companyDocMaps",
                    "companyContactMaps",
                    "companyContactMaps.contact",
                    "companyContactMaps.contact.salutation",
                    "companyContactMaps.contact.tag",
                    "companyContactMaps.contact.status",
                    "companyContactMaps.contact.communicationDetails",
                    "companyContactMaps.contact.owner",
                    "country",
                    "leadCrmInfo",
                    "accountManagerInfo",
                    "currency",
                ],
            });
            if (!company) {
                throw new common_1.NotFoundException(messages_1.errorMessages.companyNotFound);
            }
            // Fetch lookup values for the required fields
            const lookUpValues = await this.entityService.getLookupValues([
                company.industrySegmentLid,
                company?.priorityLid,
                company?.statusLid ?? 0,
                company?.companyTypeLid,
                company?.groupCompanyLid,
                company?.sourceTypeLid ?? 0,
                company?.sentimentLid ?? 0,
            ]);
            if (!lookUpValues) {
                throw new Error("Failed to fetch lookup values");
            }
            // Map the lookup values to their respective fields
            const industrySegment = lookUpValues.find((item) => item.id === company.industrySegmentLid);
            const priority = lookUpValues.find((item) => item.id === company.priorityLid);
            const status = lookUpValues.find((item) => item.id === company.statusLid);
            const companyType = lookUpValues.find((item) => item.id === company.companyTypeLid);
            const groupCompany = lookUpValues.find((item) => item.id === company.groupCompanyLid);
            const sourceType = lookUpValues.find((item) => item.id === company.sourceTypeLid);
            const sentiment = lookUpValues.find((item) => item.id === company.sentimentLid);
            // Spread the lookup values into the company object
            const enrichedCompany = {
                ...company,
                industrySegment,
                priority,
                status,
                companyType,
                groupCompany,
                sourceType,
                sentiment,
            };
            // Map company contacts
            enrichedCompany.contacts =
                company?.companyContactMaps?.map((companyContact) => {
                    return companyContact.contact;
                }) || [];
            // Validate and filter the response
            const filteredData = await this.transformCompanyResponse([
                enrichedCompany,
            ]);
            filteredData[0].editable = editValidation;
            return filteredData[0];
        }
        catch (error) {
            throw new Error(error.message);
        }
    }
    async deleteByCompanyId(id) {
        const companyId = Number(id);
        try {
            // Start a transaction to ensure atomicity
            return await this.companyRepository.manager.transaction(async (transactionalEntityManager) => {
                // Soft delete associated addresses via the mapping table
                await transactionalEntityManager.update(company_address_entity_1.CompanyAddress, { company: { id: companyId } }, { deletedAt: new Date() });
                // Soft delete associated company details
                await transactionalEntityManager.update(company_detail_entity_1.CompanyDetail, { companyId }, { deletedAt: new Date() });
                // Soft delete associated company strategy
                await transactionalEntityManager.update({ companyId }, { deletedAt: new Date() });
                // Soft delete the company itself
                const result = await transactionalEntityManager.update(company_entity_1.Company, { id: companyId }, { deletedAt: new Date() });
                return { affected: result.affected };
            });
        }
        catch (error) {
            throw new Error(`Failed to soft delete company with ID ${id}: ${error.message}`);
        }
    }
    // Retrieves a paginated list of companies with optional search and sorting functionality.
    async findAllCompanyList(page, limit, searchArray, sort, userId, searchBy) {
        try {
            const relations = [
                "companyType",
                "industrySegment",
                "companyAddresses",
                "companyAddresses.address",
                "companyAddresses.address.cityId",
                "companyAddresses.address.countryId",
                "priority",
                "sentiment",
                "leadCrmInfo",
                "accountManagerInfo",
                "currency",
                "country",
                "status",
            ];
            // const status = await this.lookUpRepository.findOne({
            //   where: { lookUpKey: DEFAULT_COMPANY_STATUS_ACTIVE },
            // });
            // Set limit to 1000 for fetching all companies
            const { data, count } = await this.scopeService.validateScope({
                entity: constants_1.DEFAULT_COMPANY_ENTITY_NAME,
                page,
                limit,
                sort: sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
                relations: relations,
                where: undefined,
                select: undefined,
                searchArray: searchArray.length === 0 ? [] : searchArray,
                userFilter: undefined,
                searchString: searchBy,
                searchOn: constants_2.companySearchObject,
            }, userId, constants_1.DEFAULT_COMPANY_ENTITY_NAME);
            if (!data || data.length === 0) {
                return {
                    data: [],
                    count: 0,
                    companyLeads: 0,
                    companyProspects: 0,
                    companyQcr: 0,
                    companyClients: 0,
                    salesOpportunityCount: 0,
                    renewalOpportunityCount: 0,
                };
            }
            const selectedFields = ["id"];
            const { data: allCompanyData } = await this.scopeService.validateScope({
                entity: constants_1.DEFAULT_COMPANY_ENTITY_NAME,
                page: 1,
                limit: count,
                sort: sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
                relations: relations,
                where: undefined,
                select: selectedFields,
                searchArray: searchArray.length === 0 ? [] : searchArray,
                userFilter: undefined,
                searchString: searchBy,
                searchOn: constants_2.companySearchObject,
            }, userId, constants_1.DEFAULT_COMPANY_ENTITY_NAME);
            const companyIds = allCompanyData.map((company) => company.id);
            const opportunityOpenStatuses = await this.lookUpRepository.find({
                where: {
                    lookUpKey: (0, typeorm_2.In)([constants_1.OPPORTUNITY_STATUS_OPEN, constants_2.OPPORTUNITY_STATUS_LOST]),
                },
            });
            const opportunityOpenStatusIds = opportunityOpenStatuses.map((status) => status.id);
            const opportunityWokrInProgresStatus = await this.lookUpRepository.findOne({
                where: {
                    lookUpKey: constants_1.OPPORTUNITY_STATUS_WORK_IN_PROGRESS,
                },
            });
            const opportunityPolicyActiveStatus = await this.lookUpRepository.findOne({
                where: {
                    lookUpKey: constants_1.OPPORTUNITY_POLICY_STATUS_ACTIVE,
                },
            });
            const QcrActivityStatus = await this.lookUpRepository.findOne({
                where: {
                    lookUpKey: constants_1.OPPORTUNITY_ACTIVITY_STATUS_CLOSED,
                },
            });
            const companyLeads = await this.getMyLeadsCount(opportunityOpenStatusIds, companyIds, userId);
            const companyProspects = await this.getMyProspectsCount(opportunityWokrInProgresStatus?.id, companyIds, userId);
            const myClients = await this.getCompanyKpiCountForMyClients(opportunityPolicyActiveStatus?.id, companyIds);
            const companyQcr = await this.getCompanyKpiCountForQcr(constants_1.QCR_GENERATION_KEY, QcrActivityStatus?.id, companyIds);
            const kpiCounts = await this.getCompanyKpis(userId, searchArray, relations);
            // Extract all unique priorityLid values from the data
            const priorityLids = [
                ...new Set(data.map((company) => company.priorityLid).filter(Boolean)),
            ];
            const industrySegmentIds = [
                ...new Set(data.map((company) => company.industrySegmentLid).filter(Boolean)),
            ];
            const companyTypeLids = [
                ...new Set(data.map((company) => company.companyTypeLid).filter(Boolean)),
            ];
            const sentimentLids = [
                ...new Set(data.map((company) => company.sentimentLid).filter(Boolean)),
            ];
            const statusLids = [
                ...new Set(data.map((company) => company.statusLid).filter(Boolean)),
            ];
            const allLids = [
                ...new Set([
                    ...priorityLids,
                    ...industrySegmentIds,
                    ...companyTypeLids,
                    ...sentimentLids,
                    ...statusLids,
                ]),
            ];
            // Fetch lookup values for all LIDs in one call
            const allLookupValues = await this.entityService.getLookupValues(allLids);
            const priorityLookup = allLookupValues.filter((item) => priorityLids.includes(item.id));
            const industrySegmentLookup = allLookupValues.filter((item) => industrySegmentIds.includes(item.id));
            const companyTypeLookup = allLookupValues.filter((item) => companyTypeLids.includes(item.id));
            const sentimentLookup = allLookupValues.filter((item) => sentimentLids.includes(item.id));
            const statusLookup = allLookupValues.filter((item) => statusLids.includes(item.id));
            // Transform company data
            const transformCompanyData = async (data) => {
                return await Promise.all(data.map(async (company) => {
                    const companyAnalytics = await this.getCompanyAnalytics(company.id);
                    return {
                        companyName: company.companyName,
                        companyId: company.id,
                        displayName: company.displayName,
                        noOfEmployees: company.noOfEmployees,
                        city: company.companyAddresses?.[0]?.address?.cityId?.name || null, // Extract city name from the first address
                        country: company.country
                            ? {
                                id: company.country.id,
                                name: company.country.name,
                            }
                            : null,
                        currency: company.currency
                            ? {
                                id: company.currency.id,
                                name: company.currency.name,
                                value: company.currency.value,
                            }
                            : null,
                        priority: priorityLookup.find((item) => item.id === company.priorityLid)
                            ?.lookUpValue ?? null,
                        industrySegment: industrySegmentLookup.find((item) => item.id === company.industrySegmentLid)?.lookUpValue ?? null,
                        companyType: companyTypeLookup.find((item) => item.id === company.companyTypeLid)?.lookUpValue ?? null,
                        status: statusLookup.find((item) => item.id === company.statusLid)
                            ?.lookUpValue ?? null,
                        sentiment: sentimentLookup.find((item) => item.id === company.sentimentLid)
                            ?.lookUpValue ?? null,
                        sumInsured: companyAnalytics?.totalSumInsured || 0,
                        salesOpportunityCount: companyAnalytics?.soCount || 0,
                        renewalOpportunityCount: 0,
                        policyCount: 0,
                        annualPremium: companyAnalytics?.totalAnnualPremium || company.annualPremium
                            ? Number(company.annualPremium)
                            : null,
                        leadCRM: company?.leadCrmInfo
                            ? `${company?.leadCrmInfo?.firstName ?? ""} ${company?.leadCrmInfo?.lastName ?? ""}`.trim()
                            : "",
                        previousInsurer: "",
                        previousTpa: "",
                        previousBroker: "",
                        salesOpportunityBeyondTheQuarterCount: 0,
                        renewalOpportunityBeyondTheQuarterCount: 0,
                    };
                }));
            };
            // Transform the data
            const transformedData = await transformCompanyData(data);
            return {
                data: transformedData,
                count,
                companyLeads: companyLeads,
                companyProspects: companyProspects,
                companyQcr: companyQcr,
                companyClients: myClients,
                salesOpportunityCount: kpiCounts.opportunityTypeCounts.find((item) => item.typeKey === "OPPORTUNITY_TYPE_SO")?.count || 0,
                renewalOpportunityCount: kpiCounts.opportunityTypeCounts.find((item) => item.typeKey === "OPPORTUNITY_TYPE_RO")?.count || 0,
            };
        }
        catch (error) {
            console.error("Error in findAllCompanyList:", error);
            throw new Error("Failed to fetch company list");
        }
    }
    async getMyLeadsCount(statusValue, companyIds, userId) {
        try {
            // Validate that statusValue is an array of IDs
            if (!Array.isArray(statusValue) || statusValue.length === 0) {
                return 0;
            }
            // Fetch companies with matching opportunities
            const companiesWithMatchingOpportunities = await this.opportunityRepository.find({
                select: ["companyId"],
                where: {
                    companyId: (0, typeorm_2.In)(companyIds),
                    statusLid: (0, typeorm_2.In)(statusValue),
                    createdBy: userId,
                },
            });
            const companiesWithOpportunities = new Set(companiesWithMatchingOpportunities.map((opportunity) => opportunity.companyId));
            // Fetch companies without opportunities
            const companiesWithoutOpportunitiesCount = await this.companyRepository
                .createQueryBuilder("company")
                .leftJoin(opportunity_entity_1.Opportunity, "opportunity", "company.id = opportunity.companyId")
                .where("company.id IN (:...companyIds)", { companyIds })
                .andWhere("opportunity.id IS NULL")
                .andWhere("company.createdBy = :userId", { userId })
                .getCount();
            return (companiesWithOpportunities.size + companiesWithoutOpportunitiesCount);
        }
        catch (error) {
            console.error("Error in getCompanyKpiCount:", error);
            throw new Error("Failed to calculate KPI count");
        }
    }
    async getMyProspectsCount(statusValue, companyIds, userId) {
        try {
            if (statusValue === undefined || statusValue === null) {
                return 0;
            }
            const companiesWithMatchingOpportunities = await this.opportunityRepository.find({
                select: ["companyId"],
                where: {
                    companyId: (0, typeorm_2.In)(companyIds),
                    statusLid: statusValue,
                    createdBy: userId,
                },
            });
            const uniqueCompanyIds = new Set(companiesWithMatchingOpportunities.map((opportunity) => opportunity.companyId));
            return uniqueCompanyIds.size;
        }
        catch (error) {
            throw new Error("Failed to calculate KPI count");
        }
    }
    async getCompanyKpiCountForQcr(activityKey, statusValue, companyIds) {
        try {
            if (statusValue === undefined || statusValue === null) {
                return 0; // Return 0 if the value is invalid
            }
            const companiesWithMatchingOpportunities = await this.opportunityRepository.find({
                select: ["companyId"],
                where: {
                    companyId: (0, typeorm_2.In)(companyIds),
                    opportunityActivityMap: {
                        activityKey: activityKey,
                        statusLid: statusValue,
                    },
                },
                relations: ["opportunityActivityMap"],
            });
            const uniqueCompanyIds = new Set(companiesWithMatchingOpportunities.map((opportunity) => opportunity.companyId));
            return uniqueCompanyIds.size;
        }
        catch (error) {
            throw new Error("Failed to calculate KPI count for QCR");
        }
    }
    async getCompanyKpiCountForMyClients(statusValue, companyIds) {
        try {
            if (statusValue === undefined || statusValue === null) {
                console.warn("getCompanyKpiCountForMyClientsInvalid statusValue:", statusValue);
                return 0; // Return 0 if the value is invalid
            }
            const companiesWithMatchingPolicies = await this.opportunityRepository.find({
                select: ["companyId"],
                where: {
                    companyId: (0, typeorm_2.In)(companyIds),
                    policy: {
                        policyStatusLid: statusValue,
                    },
                },
                relations: ["policy"],
            });
            const uniqueCompanyIds = new Set(companiesWithMatchingPolicies.map((record) => record.companyId));
            return uniqueCompanyIds.size;
        }
        catch (error) {
            console.error("Error in getCompanyKpiCountForMyClients:", error);
            throw new Error("Failed to calculate KPI count for My Clients");
        }
    }
    async updateCompany(entityManager, companyId, companyData) {
        try {
            const company = await entityManager.findOne(company_entity_1.Company, {
                where: { id: Number(companyId) },
            });
            if (!company) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, messages_1.errorMessages.companyNotFound));
            }
            const { gstDetails, groupCompanyMap, companyDocMaps, addresses, ...filteredCompanyData } = companyData;
            const updateResult = await entityManager.update(company_entity_1.Company, { id: companyId }, filteredCompanyData);
            if (updateResult.affected === 0) {
                throw new common_1.ForbiddenException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.forbidden, messages_1.errorMessages.companyUpdateFailed));
            }
            const updatedCompany = await entityManager.findOne(company_entity_1.Company, {
                where: { id: Number(companyId) },
            });
            return updatedCompany;
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError) {
                const constraint = error.constraint; // Extract the constraint name
                if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicatePanEntry) {
                    // Unique constraint violation for PAN
                    throw new Error(messages_1.errorMessages.DulicatePanEntry);
                }
                else if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicateTanEntry) {
                    // Unique constraint violation for TAN
                    throw new Error(messages_1.errorMessages.DuplicateTanEntry);
                }
            }
            throw error; // Re-throw the error to be handled by the service/controller
        }
    }
    async updateCompanyDetails(entityManager, companyId, detailsData) {
        try {
            const existingDetails = await entityManager.findOne(company_detail_entity_1.CompanyDetail, {
                where: { companyId: Number(companyId) },
            });
            if (existingDetails) {
                await entityManager.update(company_detail_entity_1.CompanyDetail, { companyId: Number(companyId) }, detailsData);
                return await entityManager.findOne(company_detail_entity_1.CompanyDetail, {
                    where: { companyId: Number(companyId) },
                });
            }
            else {
                const newDetails = entityManager.create(company_detail_entity_1.CompanyDetail, {
                    ...detailsData,
                    companyId: Number(companyId),
                });
                return await entityManager.save(newDetails);
            }
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError) {
                const constraint = error.constraint;
                if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicateGstinEntry) {
                    throw new Error(messages_1.errorMessages.DuplicateGstinEntry);
                }
            }
            throw error;
        }
    }
    async findCompanyByName(companyName) {
        return await this.companyRepository.findOne({
            where: {
                companyName: (0, typeorm_2.ILike)(companyName), // Case-insensitive comparison
            },
        });
    }
    async createGstDetail(entityManager, gstData) {
        try {
            const gstDetail = entityManager.create(company_gst_detail_entity_1.StateGstDetail, gstData);
            return await entityManager.save(gstDetail);
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError) {
                const constraint = error.constraint;
                if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicateGstinEntry) {
                    throw new Error(messages_1.errorMessages.DuplicateGstinEntry);
                }
            }
            throw error;
        }
    }
    async transformCompanyResponse(data) {
        const companyAnalytics = await this.getCompanyAnalytics(data[0]?.id);
        return data.map((company) => ({
            ...this.omitFields(company),
            details: this.omitFields(company.details),
            companyAddresses: company?.companyAddresses.map((addressEntry) => ({
                ...this.omitFields(addressEntry),
                address: {
                    ...this.omitFields(addressEntry.address),
                    addressType: {
                        id: addressEntry?.address?.addressType?.id,
                        lookUpValue: addressEntry?.address?.addressType?.lookUpValue,
                    },
                },
            })),
            stateGstDetails: company?.stateGstDetails.map(({ companyId, ...gstDetails }) => ({
                ...this.omitFields(gstDetails),
                gstCategory: {
                    id: gstDetails?.gstCategory?.id,
                    lookUpValue: gstDetails?.gstCategory?.lookUpValue,
                },
            })),
            companyDocMaps: company?.companyDocMaps.map(({ companyId, ...docMap }) => ({
                ...this.omitFields(docMap),
            })),
            contacts: company.contacts?.map((contact) => ({
                id: contact?.id,
                firstName: contact?.firstName,
                lastName: contact?.lastName,
                middleName: contact?.middleName,
                displayName: contact?.displayName,
                salutation: {
                    id: contact?.salutation?.id,
                    lookUpValue: contact?.salutation?.lookUpValue,
                },
                tag: {
                    id: contact?.tag?.id,
                    lookUpValue: contact?.tag?.lookUpValue,
                },
                status: {
                    id: contact?.status?.id,
                    lookUpValue: contact?.status?.lookUpValue,
                },
                communicationDetails: contact?.communicationDetails?.map((communication) => ({
                    id: communication?.id,
                    communicationType: communication?.communicationType,
                    communicationDetails: communication?.communicationDetails,
                    isPrimary: communication?.isPrimary,
                })),
                owner: {
                    userId: contact?.owner?.userId,
                    firstName: contact?.owner?.firstName,
                    lastName: contact?.owner?.lastName,
                },
                department: contact?.department ?? null,
                designation: contact?.designation ?? null,
            })),
            statusLid: undefined,
            priorityLid: undefined,
            industrySegmentLid: undefined,
            currencyId: undefined,
            companyTypeLid: undefined,
            groupCompanyLid: undefined,
            leadCrm: undefined,
            accountManager: undefined,
            sentimentLid: undefined,
            sourceTypeLid: undefined,
            countryId: undefined,
            companyContactMaps: undefined,
            groupCompanyMap: company?.groupCompanyMaps?.[0]
                ? {
                    groupCompanyId: company?.groupCompanyMaps[0]?.groupCompanyId,
                    groupCompanyName: company?.groupCompanyMaps[0]?.groupCompany?.companyName,
                }
                : null,
            groupCompanyMaps: undefined,
            salesOpportunityCount: companyAnalytics?.soCount || 0,
            renewalOpportunityCount: 0,
            policyCount: 0,
            annualPremium: companyAnalytics?.totalAnnualPremium || company?.annualPremium
                ? Number(company?.annualPremium)
                : null,
            sumInsured: companyAnalytics?.totalSumInsured || 0,
            currency: {
                id: company?.currency?.id,
                name: company?.currency?.name,
                value: company?.currency?.value,
            },
            leadCrmInfo: company?.leadCrmInfo?.userId
                ? {
                    id: company?.leadCrmInfo?.userId,
                    name: `${company?.leadCrmInfo?.firstName} ${company?.leadCrmInfo?.lastName}`.trim(),
                }
                : null,
            accountManagerInfo: company?.accountManagerInfo?.userId
                ? {
                    id: company?.accountManagerInfo?.userId,
                    name: `${company?.accountManagerInfo?.firstName} ${company?.accountManagerInfo?.lastName}`.trim(),
                }
                : null,
            sentiment: company?.sentiment
                ? {
                    id: company?.sentiment?.id,
                    lookUpValue: company?.sentiment?.lookUpValue,
                }
                : null,
            previousInsurer: "",
            previousTpa: "",
            previousBroker: "",
            salesOpportunityBeyondTheQuarterCount: 0,
            renewalOpportunityBeyondTheQuarterCount: 0,
        }));
    }
    omitFields(entity) {
        if (!entity) {
            return {};
        }
        const { createdAt, updatedAt, deletedAt, createdBy, updatedBy, ...rest } = entity || {};
        return rest;
    }
    // Get analytics for a specific company.
    async getCompanyAnalytics(companyId) {
        try {
            const result = await this.opportunityRepository
                .createQueryBuilder("opportunity")
                .select("COUNT(opportunity.id)", "soCount")
                .addSelect("SUM(opportunity.sumInsured)", "totalSumInsured")
                .addSelect("SUM(opportunity.premiumPaid)", "totalAnnualPremium")
                .where("opportunity.companyId = :companyId", { companyId })
                .getRawOne();
            return {
                soCount: parseInt(result.soCount, 10) || 0,
                totalSumInsured: parseFloat(result.totalSumInsured) || 0,
                totalAnnualPremium: parseFloat(result.totalAnnualPremium) || 0,
            };
        }
        catch (error) {
            throw new Error(`Failed to fetch analytics for company ID ${companyId}`);
        }
    }
    async createGroupCompanyMap(entityManager, groupCompanyMapData) {
        try {
            const groupCompanyMap = entityManager.create(group_comapny_map_entity_1.GroupCompanyMap, groupCompanyMapData);
            return await entityManager.save(groupCompanyMap);
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError &&
                error.message.includes("violates foreign key constraint")) {
                throw new common_1.NotFoundException(messages_1.errorMessages.groupComanyNotFound);
            }
            throw new Error(messages_1.errorMessages.groupCompanyCreationFailed);
        }
    }
    async createCompanyDocMap(entityManager, companyDocMapData) {
        try {
            const companyDocMap = entityManager.create(company_document_map_entity_1.CompanyDocMap, companyDocMapData);
            return await entityManager.save(companyDocMap);
        }
        catch (error) {
            throw new Error(messages_1.errorMessages.companyDocCreationFailed);
        }
    }
    async updateGstDetail(entityManager, gstData) {
        try {
            const existingGst = await entityManager.findOne(company_gst_detail_entity_1.StateGstDetail, {
                where: { id: gstData.id },
            });
            if (existingGst) {
                await entityManager.update(company_gst_detail_entity_1.StateGstDetail, { id: gstData.id }, gstData);
                const updatedGst = await entityManager.findOne(company_gst_detail_entity_1.StateGstDetail, {
                    where: { id: gstData.id },
                });
                if (!updatedGst) {
                    throw new common_1.NotFoundException(`GST detail with ID ${gstData.id} not found`);
                }
                return updatedGst;
            }
            else {
                const newGst = entityManager.create(company_gst_detail_entity_1.StateGstDetail, gstData);
                return await entityManager.save(newGst);
            }
        }
        catch (error) {
            if (error instanceof typeorm_2.QueryFailedError) {
                const constraint = error.constraint;
                if (constraint === constants_1.DUPLICATE_CONSTRAINT.duplicateGstinEntry) {
                    throw new Error(messages_1.errorMessages.DuplicateGstinEntry);
                }
            }
            throw error;
        }
    }
    async createOrUpdateGroupCompanyMap(entityManager, groupCompanyMapData) {
        try {
            // Validate existence of group_company_id and company_id
            const groupCompanyExists = await entityManager.findOne(company_entity_1.Company, {
                where: { id: groupCompanyMapData.groupCompanyId },
            });
            const companyExists = await entityManager.findOne(company_entity_1.Company, {
                where: { id: groupCompanyMapData.companyId },
            });
            if (!groupCompanyExists) {
                throw new common_1.NotFoundException(`GroupCompany with ID ${groupCompanyMapData.groupCompanyId} not found`);
            }
            if (!companyExists) {
                throw new common_1.NotFoundException(`Company with ID ${groupCompanyMapData.companyId} not found`);
            }
            // Check if a mapping already exists for the company
            const existingGroupCompanyMap = await entityManager.findOne(group_comapny_map_entity_1.GroupCompanyMap, {
                where: { companyId: groupCompanyMapData.companyId },
            });
            if (existingGroupCompanyMap) {
                // Update the existing mapping
                await entityManager.update(group_comapny_map_entity_1.GroupCompanyMap, { id: existingGroupCompanyMap.id }, groupCompanyMapData);
                const updatedGroupCompanyMap = await entityManager.findOne(group_comapny_map_entity_1.GroupCompanyMap, { where: { id: existingGroupCompanyMap.id } });
                if (!updatedGroupCompanyMap) {
                    throw new common_1.NotFoundException(`GroupCompanyMap with ID ${existingGroupCompanyMap.id} not found`);
                }
                return updatedGroupCompanyMap;
            }
            else {
                // Validate existence of group_company_id and company_id
                const groupCompanyExists = await entityManager.findOne(company_entity_1.Company, {
                    where: { id: groupCompanyMapData.groupCompanyId },
                });
                const companyExists = await entityManager.findOne(company_entity_1.Company, {
                    where: { id: groupCompanyMapData.companyId },
                });
                if (!groupCompanyExists) {
                    throw new common_1.NotFoundException(`GroupCompany with ID ${groupCompanyMapData.groupCompanyId} not found`);
                }
                if (!companyExists) {
                    throw new common_1.NotFoundException(`Company with ID ${groupCompanyMapData.companyId} not found`);
                }
                // Create new group company map
                return this.createGroupCompanyMap(entityManager, groupCompanyMapData);
            }
        }
        catch (error) {
            console.error("Error in createOrUpdateGroupCompanyMap:", error);
            throw error;
        }
    }
    async deleteGroupCompanyMap(entityManager, companyId) {
        try {
            const deletingGroupCompany = await entityManager.delete(group_comapny_map_entity_1.GroupCompanyMap, {
                companyId: companyId,
            });
            return deletingGroupCompany;
        }
        catch (error) {
            throw new common_1.NotFoundException(`GroupCompanyMap with companyId ${companyId} not found`);
        }
    }
    async createOrUpdateCompanyDocMap(entityManager, companyDocMapData) {
        try {
            // Check if the document ID exists in the fileupload table
            const documentExists = await entityManager
                .getRepository(file_upload_entity_1.FileUpload)
                .findOne({
                where: { id: companyDocMapData.documentId },
            });
            if (!documentExists) {
                throw new common_1.NotFoundException(`Document with ID ${companyDocMapData.documentId} not found in fileupload table`);
            }
            if (companyDocMapData.id) {
                // Update existing document map
                await entityManager.update(company_document_map_entity_1.CompanyDocMap, { id: companyDocMapData.id }, companyDocMapData);
                const companyDocMap = await entityManager.findOne(company_document_map_entity_1.CompanyDocMap, {
                    where: { id: companyDocMapData.id },
                });
                if (!companyDocMap) {
                    throw new common_1.NotFoundException(`CompanyDocMap with ID ${companyDocMapData.id} not found`);
                }
                return companyDocMap;
            }
            else {
                return this.createCompanyDocMap(entityManager, companyDocMapData);
            }
        }
        catch (error) {
            console.error("Error in createOrUpdateCompanyDocMap:", error);
            throw error;
        }
    }
    async CompanyList(page, limit, search, userId, entityIds) {
        try {
            const status = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.DEFAULT_COMPANY_STATUS_ACTIVE },
            });
            console.log("Status:", status);
            const result = await this.scopeService.validateScope({
                entity: company_entity_1.Company,
                page,
                limit,
                sort: [{ field: "companyName", order: "ASC" }],
                relations: ["country"],
                where: { statusLid: status?.id ?? undefined },
                select: [
                    "id",
                    "companyName",
                    "displayName",
                    "country.id",
                    "country.name",
                ],
                searchArray: [
                    ...(search
                        ? [
                            {
                                searchBy: "displayName",
                                searchValue: `%${search}%`,
                            },
                        ]
                        : []),
                ],
                entityIds,
            }, userId, "Company");
            // Commented out old code and implemented new scope-based query
            // const [data, count] = await this.companyRepository.findAndCount({
            //   where: search
            //     ? [
            //         {
            //           createdBy: userId,
            //           statusLid: status?.id ?? undefined, // active status
            //           companyName: ILike(`%${search}%`),
            //         },
            //         {
            //           createdBy: userId,
            //           statusLid: status?.id ?? undefined,
            //           displayName: ILike(`%${search}%`),
            //         },
            //       ]
            //     : { createdBy: userId, statusLid: status?.id ?? undefined }, // Fallback if search is empty
            //   order: { companyName: "ASC" }, // Sort by companyName in alphabetical order
            //   skip: (page - 1) * limit,
            //   take: limit,
            //   select: ["id", "companyName", "displayName"],
            // });
            return {
                data: result.data,
                count: result.count,
            };
        }
        catch (error) {
            console.error("Error in findCompanyNameList:", error);
            throw new Error("Failed to fetch company name list");
        }
    }
    async getCompanyListData(fields, relations, whereCondition, contactId) {
        try {
            const entityName = constants_1.DEFAULT_COMPANY_ENTITY_NAME;
            const data = await this.entityService.getListOfValues(entityName, fields, whereCondition, relations);
            return this.transformResponse(data, contactId);
        }
        catch (error) {
            return error;
        }
    }
    async transformResponse(data, contactId) {
        if (!data)
            return null;
        return {
            id: data?.id,
            companyName: data?.companyName,
            displayName: data?.displayName,
            companyAddresses: (data?.companyAddresses || []).map((address) => ({
                id: address?.address?.id,
                address1: address?.address?.address1,
                cityId: {
                    id: address?.address?.cityId?.id,
                    name: address?.address?.cityId?.name,
                },
            })),
            contacts: (data?.companyContactMaps || [])
                .filter((companyContact) => contactId !== companyContact?.contact?.id)
                .map((companyContact) => ({
                id: companyContact?.contact?.id,
                firstName: companyContact?.contact?.firstName,
                lastName: companyContact?.contact?.lastName,
                middleName: companyContact?.contact?.middleName,
                displayName: companyContact?.contact?.displayName,
            })),
        };
    }
    async fetchByCompanyId(companyId) {
        return await this.companyRepository.findOne({
            where: { id: companyId },
        });
    }
    async getCompanyKpis(userId, searchFilters, relations) {
        // Step 1: Fetch stage lookup values
        const stageLookUpIds = await this.lookUpRepository.find({
            where: {
                lookUpKey: (0, typeorm_2.In)(constants_1.OPPORTUNITY_STAGES),
            },
        });
        // Transform lookup values into key-value pairs
        const stageKeyValuePairs = stageLookUpIds.map((stage) => ({
            key: stage.lookUpKey,
            id: stage.id,
        }));
        // Fetch Opportunity Types (SO / RO)
        const opportunityTypeLookUpIds = await this.lookUpRepository.find({
            where: {
                lookUpKey: (0, typeorm_2.In)(constants_1.OPPORTUNITY_TYPES),
            },
        });
        const typeKeyValuePairs = opportunityTypeLookUpIds.map((type) => ({
            key: type.lookUpKey,
            id: type.id,
        }));
        // Step 2: Dynamically filter companies based on searchFilters
        const companyQuery = this.companyRepository.createQueryBuilder("company");
        const relationPaths = typeof relations === "string"
            ? [relations]
            : Array.isArray(relations)
                ? relations
                : [];
        for (const path of relationPaths) {
            const alias = path.replace(/\./g, "_");
            const segments = path.split(".");
            const parent = segments.length > 1 ? segments.slice(0, -1).join("_") : "company";
            const relationName = segments[segments.length - 1];
            companyQuery.leftJoinAndSelect(`${parent === "company" ? "company" : parent}.${relationName}`, alias);
        }
        // Dynamically add filters from searchFilters
        if (Array.isArray(searchFilters) && searchFilters.length > 0) {
            searchFilters.forEach(({ searchBy, searchValue }, index) => {
                const paramKey = `searchValue${index}`;
                let alias, column;
                if (searchBy.includes(".")) {
                    const parts = searchBy.split(".");
                    column = parts.pop();
                    alias = parts.join("_");
                }
                else {
                    alias = "company";
                    column = searchBy;
                }
                if (Array.isArray(searchValue)) {
                    companyQuery.andWhere(`${alias}.${column} IN (:...${paramKey})`, {
                        [paramKey]: searchValue,
                    });
                }
                else {
                    companyQuery.andWhere(`${alias}.${column} ILIKE :${paramKey}`, {
                        [paramKey]: `%${searchValue}%`,
                    });
                }
            });
        }
        // Execute the query to get filtered company IDs
        const filteredCompanies = await companyQuery
            .select("company.id")
            .getRawMany();
        const companyIds = filteredCompanies.map((company) => company.id);
        // Step 3: Query the opportunity table for counts grouped by stageLid
        const stageCounts = await this.opportunityRepository
            .createQueryBuilder("opportunity")
            .select("opportunity.stageLid", "stageLid")
            .addSelect("COUNT(opportunity.id)", "count")
            .where("opportunity.companyId IN (:...companyIds)", { companyIds }) // Filter by company IDs
            .groupBy("opportunity.stageLid")
            .getRawMany();
        const typeCounts = await this.opportunityRepository
            .createQueryBuilder("opportunity")
            .select("opportunity.opportunityTypeLid", "opportunityTypeLid")
            .addSelect("COUNT(opportunity.id)", "count")
            .where("opportunity.companyId IN (:...companyIds)", { companyIds })
            .groupBy("opportunity.opportunityTypeLid")
            .getRawMany();
        const opportunityTypeResults = typeCounts.map((type) => {
            const typeKey = typeKeyValuePairs.find((item) => item.id === type.opportunityTypeLid)
                ?.key || "Unknown";
            return {
                typeKey,
                count: parseInt(type.count, 10),
            };
        });
        // Step 4: Map the stage counts to stage keys
        const result = stageCounts.map((stage) => {
            const stageKey = stageKeyValuePairs.find((item) => item.id === stage.stageLid)?.key ||
                "Unknown";
            return {
                stageKey,
                count: parseInt(stage.count, 10),
            };
        });
        return {
            stageCounts: result,
            opportunityTypeCounts: opportunityTypeResults,
        };
    }
    async getCompanies(page, limit, userId, search) {
        try {
            const relations = [
                "groupCompanyMaps",
                "groupCompanyMaps.groupCompany",
                "status",
                "country",
            ];
            const { data: allData } = await this.scopeService.validateScope({
                entity: constants_1.DEFAULT_COMPANY_ENTITY_NAME,
                page: page,
                limit: 0,
                sort: [{ field: "companyName", order: "ASC" }],
                relations: relations,
            }, userId, constants_1.DEFAULT_COMPANY_ENTITY_NAME);
            const parentToChildrenMap = {};
            allData.forEach((company) => {
                company.groupCompanyMaps?.forEach((map) => {
                    const parentId = map.groupCompany?.id;
                    if (parentId) {
                        if (!parentToChildrenMap[parentId]) {
                            parentToChildrenMap[parentId] = [];
                        }
                        parentToChildrenMap[parentId].push({
                            id: company.id,
                            companyName: company.companyName,
                            country: company.country?.name || null,
                            status: company.status?.lookUpValue || "INACTIVE",
                        });
                    }
                });
            });
            // Apply filtering logic
            const filteredData = allData
                .map((company) => ({
                id: company.id,
                companyName: company.companyName,
                country: company.country ? company.country.name : null,
                status: company.status?.lookUpValue || "INACTIVE",
                childCompanies: parentToChildrenMap[company.id] || [],
            }))
                .filter((company) => {
                // Perform search on companyName and childCompanies array
                const matchesParent = search
                    ? company.companyName.toLowerCase().includes(search.toLowerCase())
                    : true;
                const matchingChildren = company.childCompanies.filter((child) => search
                    ? child.companyName.toLowerCase().includes(search.toLowerCase())
                    : true);
                // If parent matches or any child matches, include the parent with matching children
                if (matchesParent || matchingChildren.length > 0) {
                    company.childCompanies = matchingChildren;
                    return true;
                }
                return false;
            })
                .filter((company, _, array) => {
                // Ensure no redundant objects: if an object is a child, it should not appear as a parent
                return !array.some((parent) => parent.childCompanies.some((child) => child.id === company.id));
            });
            // Apply pagination after filtering
            const startIndex = (page - 1) * limit;
            const paginatedData = filteredData.slice(startIndex, startIndex + limit);
            return {
                data: paginatedData,
                count: filteredData.length, // Total count after filtering
            };
        }
        catch (error) {
            console.error("Error in findCompanyNameList:", error);
            throw new Error("Failed to fetch company name list");
        }
    }
    async getGroupCompanies(entityManager, page, limit, search, userId) {
        try {
            const childCompanies = await entityManager.find(group_comapny_map_entity_1.GroupCompanyMap, {
                select: ["companyId"], // Select only the companyId column
            });
            const childCompanyIds = childCompanies.map((child) => child.companyId);
            const { data, count } = await this.entityService.fetchEntityList(constants_1.DEFAULT_COMPANY_ENTITY_NAME, page, limit, [{ field: "companyName", order: "ASC" }], [], { id: (0, typeorm_2.Not)((0, typeorm_2.In)(childCompanyIds)), createdBy: userId }, ["id", "companyName", "displayName"], undefined, undefined, search, ["companyName"]);
            return {
                data: data,
                count: count,
            };
        }
        catch (error) {
            console.error("Error in findCompanyNameList:", error);
            throw new Error(messages_1.errorMessages.groupCompanyListNotFound);
        }
    }
    async getCountryId(entityManager, userId) {
        const user = await entityManager.findOne(user_1.User, {
            where: { userId },
            relations: [
                "branch",
                "branch.organisation",
                "branch.organisation.country",
            ],
        });
        if (!user) {
            throw new common_1.NotFoundException(`User with ID ${userId} not found`);
        }
        if (user?.branch?.organisation?.country) {
            return user.branch.organisation.country.id;
        }
        return null;
    }
    async getCurrencyId(entityManager, countryId) {
        const currency = await entityManager.findOne(entities_1.Currency, {
            where: { countryId: countryId },
            relations: ["country"],
        });
        if (!currency) {
            throw new common_1.NotFoundException(`Currency not found for the given country ID ${countryId}`);
        }
        return currency.id;
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    async isPriorityCompany(entityManager, companyPriorityId) {
        if (!companyPriorityId)
            return false;
        try {
            const match = await entityManager.findOne(look_up_entity_1.LookUp, {
                where: {
                    id: companyPriorityId,
                    lookUpKey: (0, typeorm_2.In)([constants_2.PRIORITY_VIMP, constants_2.PRIORITY_HIGH, constants_2.PRIORITY_IMP]),
                },
                select: ["id"],
            });
            return !!match;
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
};
exports.CompanyRepository = CompanyRepository;
exports.CompanyRepository = CompanyRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(company_entity_1.Company)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(opportunity_entity_1.Opportunity)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _d : Object, typeof (_e = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _e : Object])
], CompanyRepository);
